export enum paths {
  'settings' = 'settings',
}
